
import { Component, namespace, Prop, Vue } from 'bits/vue'
import OzAvatar from 'library/v4/components/OzAvatar.vue'
import OzBaseButton from 'library/v4/components/OzBaseButton.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import RoundedHexagonIcon from 'library/v4/components/rounded-hexagon-icon.vue'

@Component({ components: { RoundedHexagonIcon, OzIcon, OzAvatar, OzBaseButton } })
export default class ActionableChiclet extends Vue {
  @namespace('browser').Getter isSmallerThanTabletPortrait!: boolean
  @Prop({ default: '' }) iconName!: string
  /**
   * @values pink green orange blue
   */
  @Prop({ default: 'green' }) color!: string
  @Prop({ default: undefined }) hiddenInputId!: string
  @Prop({ default: false }) disabled!: boolean
  @Prop({ default: false }) imageUrl!: string
  @Prop({ default: false }) imageAltText!: string

  get mobileIconColorClasses(): string[] {
    switch (this.color) {
      case 'green':
        return ['text-park']
      case 'orange':
        return ['text-tangerine']
      case 'pink':
        return ['text-padlet-pink']
      case 'blue':
        return ['text-oceanic']
    }
    return []
  }

  get colorClasses(): string[] {
    switch (this.color) {
      case 'green':
        return ['bg-park-0']
      case 'orange':
        return ['bg-tangerine-0']
      case 'pink':
        return ['bg-padlet-pink-0']
      case 'blue':
        return ['bg-oceanic-0']
    }
    return []
  }

  get hoverColorClasses(): string[] {
    switch (this.color) {
      case 'green':
        return ['hover-hover:hover:animate-pulse-bg-color pulse-bg-from-park-0 pulse-bg-to-park-200']
      case 'orange':
        return ['hover-hover:hover:animate-pulse-bg-color pulse-bg-from-tangerine-0 pulse-bg-to-tangerine-200']
      case 'pink':
        return ['hover-hover:hover:animate-pulse-bg-color pulse-bg-from-padlet-pink-0 pulse-bg-to-padlet-pink-200']
      case 'blue':
        return ['hover-hover:hover:animate-pulse-bg-color pulse-bg-from-oceanic-0 pulse-bg-to-oceanic-200']
    }
    return []
  }

  get interactionColorClasses(): string[] {
    if (this.disabled) return []
    switch (this.color) {
      case 'green':
        return [
          // Focus with tabbing
          'hover-hover:focus:bg-park-200',
          'focus:bg-park-200',
          // Tap
          'hover-hover:active:bg-park-200',
          // Mobile tap
          'active:bg-park-200',
        ]
      case 'orange':
        return [
          'hover-hover:focus:bg-tangerine-100',
          'focus:bg-tangerine-100',
          'hover-hover:active:bg-tangerine-100',
          'active:bg-tangerine-100',
        ]
      case 'pink':
        return [
          'hover-hover:focus:bg-padlet-pink-100',
          'focus:bg-padlet-pink-100',
          'hover-hover:active:bg-padlet-pink-100',
          'active:bg-padlet-pink-100',
        ]
      case 'blue':
        return [
          'hover-hover:focus:bg-padlet-pink-100',
          'focus:bg-padlet-pink-100',
          'hover-hover:active:bg-oceanic-100',
          'active:bg-oceanic-100',
        ]
    }
    return []
  }

  onClick(): void {
    if (this.hiddenInputId) document.getElementById(this.hiddenInputId)?.click()
    this.$emit('click')
  }
}
